<template>
  <v-data-table
    :headers="headers"
    :items="data"
    item-key="id"
    :loading="loading"
    :no-data-text="noDataText"
  >
    <template v-slot:item.domainId="{ item }">
      <v-tooltip v-if="item.domainId !== 2" top>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on">{{ getIcon(item.domainId) }}</v-icon>
        </template>
        <span>{{ item.domainName }}</span>
      </v-tooltip>

      <v-tooltip v-else top>
        <template v-slot:activator="{ on }">
          <v-img
            src="@/assets/hot_water_gray.png"
            width="25px"
            height="25px"
            v-on="on"
          ></v-img>
        </template>
        <span>Hot water</span>
      </v-tooltip>
    </template>
    <template v-slot:item.valid_from="{ item }">
      {{ formatDate(item.valid_from) }}
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    noDataText: {
      type: String,
      default: "No data available",
    },
  },
  data() {
    return {
      headers: [
        { text: "Domain", value: "domainId" },
        {
          text: "Domain Service",
          value: "description",
        },
        {
          text: "Level Value",
          value: "level_value",
        },

        {
          text: "Additional Share",
          value: "additional_share",
        },
        {
          text: "Additional Level Value",
          value: "additional_level_value",
          align: "center",
        },
        {
          text: "Domain Presence",
          value: "domain_presence",
        },
        {
          text: "Service Applicable",
          value: "service_applicable",
          align: "center",
        },
        {
          text: "Valid From",
          value: "valid_from",
        },
      ],
      domainIcons: [
        "device_thermostat",
        "ac_unit",
        "ac_unit",
        "air",
        "emoji_objects",
        "bolt",
        "vertical_shades_closed",
        "electric_car",
        "dvr",
      ],
    };
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleDateString();
    },
    getIcon(id) {
      return this.domainIcons[id - 1];
    },
  },
};
</script>
